<ng-container *ngFor="let filterType of filterTypeList; trackBy: trackByKey">
  <div
    class="filter-type-item"
    attr.data-test="select-filter-type-{{ filterType.key }}"
    [class.selected]="filterType === selectedFilterType"
    (click)="itemSelected(filterType)"
  >
    <capra-icon
      [class.discrete]="isDiscreteFilterStep(filterType.step)"
      [class.continuous]="!isDiscreteFilterStep(filterType.step)"
      [icon]="filterType.icon"
    ></capra-icon>
    <span class="filter-type-label">{{ filterType.label }}</span>
  </div>
</ng-container>
<div class="action-buttons">
  <capra-button
    data-test="filter-modal-cancel-button"
    text="Cancel"
    variant="secondary"
    color="neutral"
    (clicked)="doCancel()"
  ></capra-button>
  <capra-button data-test="filter-modal-next-button" text="Next" color="default" (clicked)="doNext()"></capra-button>
</div>
